<template>
    <div class="flex justify-center items-center">
        <div class="w-full flex flex-col justify-center items-center p-4">
            <img alt="Activix Logo" class="w-full max-w-64 mb-8 | md:max-w-72" src="/img/activix-dark-mono.png">

            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        //
    };
</script>
